/**
 * The order fields are listed in everywhere in Content: what a shopper reads first (title,
 * description, highlights), then what places and matches the product (brand, category,
 * identifiers), then images and the filterable attributes, then measures and logistics — the
 * scoring rules' tiers (content 60 · identifiers 20 · attributes 20), most important first.
 */
export const FIELD_PRIORITY: readonly string[] = [
  // Content — what a shopper reads.
  'TITLE',
  'DESCRIPTION',
  'PRODUCT_HIGHLIGHT',
  'BULLETS',
  'PRODUCT_DETAIL',
  'SHORT_TITLE',
  'STRUCTURED_TITLE',
  'STRUCTURED_DESCRIPTION',
  'KEYWORDS',
  // Classification & identifiers — what places and matches the product.
  'BRAND',
  'GOOGLE_PRODUCT_CATEGORY',
  'CATEGORY',
  'PRODUCT_TYPE',
  'GTIN',
  'MPN',
  'IDENTIFIER_EXISTS',
  'ITEM_GROUP_ID',
  // Images, then the attributes shoppers filter on.
  'IMAGE_LINK',
  'ADDITIONAL_IMAGE_LINK',
  'COLOR',
  'SIZE',
  'SIZE_TYPE',
  'SIZE_SYSTEM',
  'MATERIAL',
  'PATTERN',
  'GENDER',
  'AGE_GROUP',
  'CONDITION',
  'AVAILABILITY',
  'ADDITIONAL_FEATURES',
  // Measures and packaging.
  'PRODUCT_LENGTH',
  'PRODUCT_WIDTH',
  'PRODUCT_HEIGHT',
  'PRODUCT_WEIGHT',
  'IS_BUNDLE',
  'MULTIPACK',
  'SHIPPING_LENGTH',
  'SHIPPING_WIDTH',
  'SHIPPING_HEIGHT',
  'SHIPPING_WEIGHT',
];

/** A field's place in `FIELD_PRIORITY` (codes matched without case); unknown fields sort last. */
export function fieldRank(field: string): number {
  const index = FIELD_PRIORITY.indexOf(field.toUpperCase());
  return index === -1 ? FIELD_PRIORITY.length : index;
}
